import { gql } from '@apollo/client'

import { SUBSCRIPTION_TYPE_FRAGMENT } from '@/graphql'

export const GET_AVAILABLE_PLANS = gql`
  query GetAvailablePlans {
    availablePlans {
      ...SubscriptionType
    }
  }
  ${SUBSCRIPTION_TYPE_FRAGMENT}
`
